import React, { useState } from "react";
import { Typography, Box, TextField, Button, Link } from "@mui/material";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import Alerta from "../../../components/Alerta";


const Registro = () => {
    const navigate = useNavigate();
    // Estados para los valores de los campos
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
	const [alerta, cambiarAlerta] = useState({});

    const handleChange = (e) => {
		switch(e.target.name){
            case 'fullName':
                setFullName(e.target.value);
                break;
			case 'email':
				setEmail(e.target.value);
				break;
			case 'password':
				setPassword(e.target.value);
				break;
			case 'confirmPassword':
				setConfirmPassword(e.target.value);
				break;
			default:
				break;
		}
	}

    // Manejo del registro
	const handleSubmit = async (e) => {
		e.preventDefault();
		cambiarEstadoAlerta(false);
		cambiarAlerta({});

		// Comprobamos del lado del cliente que el correo sea valido.
		const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
		if( !expresionRegular.test(email) ){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Por ingresa un correo electrónico valido'
			});
			return;
		}

		if(email === '' || password === '' || confirmPassword === ''){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Por favor rellena todos los datos'
			});
			return;
		}

		if(password !== confirmPassword){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Las contraseñas no son iguales'
			});
			return;
		}

		try {
			await createUserWithEmailAndPassword(auth, email, password);
            console.log('Estoy adentro');
			navigate('/dashboard');
		} catch(error) {
			cambiarEstadoAlerta(true);

			let mensaje;
			switch(error.code){
				case 'auth/invalid-password':
					mensaje = 'La contraseña tiene que ser de al menos 6 caracteres.'
					break;
				case 'auth/email-already-in-use':
					mensaje = 'Ya existe una cuenta con el correo electrónico proporcionado.'
				break;
				case 'auth/invalid-email':
					mensaje = 'El correo electrónico no es válido.'
				break;
				default:
					mensaje = 'Hubo un error al intentar crear la cuenta.'
				break;
			}

			cambiarAlerta({tipo: 'error', mensaje: mensaje});
		}

	}

    return(
        <Box component="main" maxWidth="xs" sx={{ flexDirection: 'row',  width: '100%', height: '100%', padding: '10%', justifyContent: 'center' }}>
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Registro de Usuario
                </Typography>

                {/* Formulario de Registro */}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                {/* Campo de nombre completo */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="fullName"
                    label="Nombre Completo"
                    name="fullName"
                    size='small'
                    autoFocus
                    value={fullName}
                    onChange={handleChange}
                />

                {/* Campo de correo electrónico */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    size='small'
                    id="email"
                    label="Correo Electrónico"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={handleChange}
                />

                {/* Campo de contraseña */}
                <TextField
                    margin="normal"
                    required
                    size='small'
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"
                    value={password}
                    onChange={handleChange}
                />

                {/* Campo de confirmación de contraseña */}
                <TextField
                    margin="normal"
                    required
                    size='small'
                    fullWidth
                    name="confirmPassword"
                    label="Confirmar Contraseña"
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={handleChange}
                />

                {/* Botón de Registro */}
                <Button
                    type="submit"
                    fullWidth
                    size='small'
                    variant="outlined"
                    color="#5d0303"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Registrarse
                </Button>

                {/* Enlace para redirigir a la página de login */}
                <Link href="/login" variant="body2" sx={{ display: 'block', textAlign: 'center', mt: 2 }}>
                    ¿Ya tienes una cuenta? Inicia sesión
                </Link>
                </Box>
            </Box>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={cambiarAlerta}
            /> 
        </Box>
    );
}

export default Registro;